var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#star_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.804.742L8.084 6.26l-6.088.887c-1.092.159-1.53 1.505-.738 2.275l4.404 4.292-1.041 6.063c-.188 1.095.966 1.916 1.933 1.404L12 18.317l5.446 2.863c.966.508 2.12-.309 1.933-1.404l-1.042-6.063 4.404-4.292c.792-.77.355-2.116-.737-2.275l-6.088-.887-2.72-5.517c-.488-.983-1.9-.996-2.392 0z",
    fill: "#3555F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "star_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v21.333H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/star.32295263ec7d14d7c4071098d18c528f.svg";
export { SvgStar as ReactComponent };